var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tooltip',{attrs:{"label":_vm.label,"text":_vm.text,"show-asterisk":false,"btn-class":"flex items-center-center bg-white w-8 h-8 rounded-full bg-pale-greenish-blue"},on:{"onMobileOpen":_vm.handleClick}})}
var staticRenderFns = []

export { render, staticRenderFns }